import React from "react";
import Header from "components/Header";
import Footer from "components/Footer";

export default function HomeLayout({ children }) {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
